import { HeartAddOutlineIcon, HeartSolidIcon } from '@ikyucom/design-system-icons-react'
import { useCallback, useState } from 'react'
import { css, cva } from '~/styled-system/css'
import type { WithCss } from '~/styled-system/types'
import { IconButton } from '~/ui/IconButton'
import type { FavoriteState } from './types'

const styles = cva({
  variants: {
    isFavorite: {
      true: { color: 'accent.pink' },
    },
    animate: {
      true: {},
    },
  },
  compoundVariants: [
    {
      isFavorite: true,
      animate: true,
      css: { animation: 'favorite' },
    },
  ],
})

export type Variant = { noBackground?: false; size?: 'sm' | 'md' } | { noBackground: true }

export function FavoriteButton(
  props: {
    state: FavoriteState
    isPending: boolean
    toggle: () => void
  } & WithCss &
    Variant
) {
  // お気に入り追加のボタン押下時のみアニメーションを表示する
  const [animate, setAnimate] = useState<boolean>(false)
  const onClick = useCallback(() => {
    setAnimate(true)
    if (!props.isPending) {
      props.toggle()
    }
  }, [props.toggle, props.isPending])

  if (props.noBackground) {
    if (props.state.type === 'loading') {
      return <HeartSolidIcon className={css({ fontSize: '[20px]', color: 'gray.100' })} />
    }
    const Icon = props.state.isFavorite ? HeartSolidIcon : HeartAddOutlineIcon
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={props.isPending}
        aria-label={props.state.isFavorite ? 'お気に入りを解除' : 'お気に入りに追加'}
      >
        <Icon
          className={css(
            { fontSize: '[20px]', color: 'tertiary' },
            styles.raw({ isFavorite: props.state.isFavorite, animate })
          )}
        />
      </button>
    )
  }

  if (props.state.type === 'loading') {
    return <IconButton theme="filled" size={props.size} disabled />
  }

  return (
    <IconButton
      theme="filled"
      size={props.size}
      Icon={props.state.isFavorite ? HeartSolidIcon : HeartAddOutlineIcon}
      disabled={props.isPending}
      onClick={onClick}
      css={props.css}
      iconCss={styles.raw({ isFavorite: props.state.isFavorite, animate })}
      aria-label={props.state.isFavorite ? 'お気に入りを解除' : 'お気に入りに追加'}
    />
  )
}
